import * as $ from 'jquery';
import Chart from 'chart.js';
import { COLORS } from '../../constants/colors';

export default (function () {
  // ------------------------------------------------------
  // @Line Charts
  // ------------------------------------------------------

  const lineChartBox = document.getElementById('bar-chart-payroll');

  if (lineChartBox) {
    const lineCtx = lineChartBox.getContext('2d');

    var jsonData = $.ajax({
      url: '/admin/statistics/chart',
      dataType: 'json'
    }).done(function (res) {
      // Paghe chart
      var labels = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novebre', 'Dicembre'];
      var data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

      res['statisticsPayrolls'].forEach(function(p) {
        let name = p.month.toLowerCase();
        name = name.substr(0, 1).toUpperCase() + name.substr(1);

        let q = labels.indexOf(name);

        if(q > -1) {
          p.counters.forEach(function(x) {
            data[q] += parseInt(x.count);
          });
        }
      });

        var tmpData = {
          labels: labels,
          datasets: [{
            label: 'Totale downloads paghe',
            backgroundColor      : 'rgba(237, 231, 246, 0.5)',
            borderColor          : COLORS['deep-purple-500'],
            pointBackgroundColor : COLORS['deep-purple-700'],
            borderWidth          : 2,
            data: data
          }]
        };

        var chartLine = new Chart(lineChartBox, {
          type: 'bar',
          data: tmpData,
          options: {
            responsive: true,
            scales: {
              yAxes: [{
                  ticks: {
                      beginAtZero: true,
                      min: 0,
                      stepSize: 1
                  }
              }]
            }
          }
        });
        // Documenti chart
    });
  }

  // ------------------------------------------------------
  // @Line CUD chart lines
  // ------------------------------------------------------

  const lineCudsChartBox = document.getElementById('bar-chart-cuds');

  if (lineCudsChartBox) {
    const lineCtx = lineCudsChartBox.getContext('2d');

    var jsonData = $.ajax({
      url: '/admin/statistics/chart',
      dataType: 'json'
    }).done(function (res) {
      // Paghe chart
      var labels = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novebre', 'Dicembre'];
      var data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

      res['statisticCuds'].forEach(function(p) {
        const currentDate = new Date();
        let name = labels[currentDate.getMonth()].toLowerCase();
        name = name.substr(0, 1).toUpperCase() + name.substr(1);

        let q = labels.indexOf(name);

        if(q > -1) {
          p.counters.forEach(function(x) {
            data[q] += parseInt(x.count);
          });
        }
      });

        var tmpData = {
          labels: labels,
          datasets: [{
            label: 'Totale downloads cud',
            backgroundColor      : 'rgba(237, 231, 246, 0.5)',
            borderColor          : COLORS['deep-purple-500'],
            pointBackgroundColor : COLORS['deep-purple-700'],
            borderWidth          : 2,
            data: data
          }]
        };

        var chartLine = new Chart(lineCudsChartBox, {
          type: 'bar',
          data: tmpData,
          options: {
            responsive: true,
            scales: {
              yAxes: [{
                  ticks: {
                      beginAtZero: true,
                      min: 0,
                      stepSize: 1
                  }
              }]
            }
          }
        });
        // Documenti chart
    });
  }

}())



// WEBPACK FOOTER //
// ./resources/js/charts/chartJS/index.js